import "./TagOverflowHandle.css";
import React, { useEffect, useRef, useState, useLayoutEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import GenericTagComp from "../genericComponents/tag/GenericTagComp";

const TagOverflowHandler = ({ tabConfig = [], handleSideCard, rowData ,childSc}) => {
  const containerRef = useRef(null);
  const moreRef = useRef(null);
  const itemRefs = useRef([]);
  const [visibleCount, setVisibleCount] = useState(tabConfig.length);
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownStyle, setDropdownStyle] = useState({});

  const calculateVisibleTags = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;

    const containerRight = container.getBoundingClientRect().right;

    let count = 0;
    for (let i = 0; i < tabConfig.length; i++) {
      const el = itemRefs.current[i];
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.right <= containerRight) {
          count++;
        } else {
          break;
        }
      }
    }

    setVisibleCount(count);
  }, [tabConfig]);

  useLayoutEffect(() => {
    calculateVisibleTags();
  }, [tabConfig, calculateVisibleTags]);

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      requestAnimationFrame(calculateVisibleTags);
    });
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, [calculateVisibleTags]);

  const handleMoreClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const rect = moreRef.current?.getBoundingClientRect();
    if (rect) {
      setDropdownStyle({
        position: "absolute",
        top: `${(rect.bottom + window.scrollY + 4) / 16}rem`, // 4px offset
        left: `${(rect.left + window.scrollX) / 16}rem`,
        zIndex: 900,
        backgroundColor: "#fff",
        boxShadow: "0 0.25rem 0.75rem rgba(0, 0, 0, 0.15)",
        borderRadius: "0.375rem",
        padding: "0.5rem",
        minWidth: "9.375rem",
      });
      setShowDropdown(true);
    }
  };

  const Dropdown = showDropdown
    ? ReactDOM.createPortal(
        <div
          className="tag-overflow-dropdown"
          style={dropdownStyle}
          onMouseLeave={() => setShowDropdown(false)}
        >
          {tabConfig.slice(visibleCount).map((item) => (
            <div
              key={item.key}
              className="tag-overflow-dropdown-item"

            >
              <GenericTagComp
                color={item.color}
                text={item.label}
                onChipClick={(e) => {
                  handleSideCard(e, rowData, item.key,childSc);
                  setShowDropdown(false);
                }}
                tagIcon={item?.tagIcon}
              />
            </div>
          ))}
        </div>,
        document.body
      )
    : null;

    // console.log("visibleCount",visibleCount)
  return (
    <>
      <div
        className="tag-overflow-doc-container"
        ref={containerRef}
        // style={{
        //   display: "flex",
        //   gap: "0.5rem",
        //   flexDirection:"row",
        //   overflow: "hidden",
        //   marginRight:"2rem",
        //   justifyContent:"flex-start",
        //   border:"solid 1px red"
        // }}
      >
        {tabConfig.slice(0, visibleCount).map((item, index) => (
          <div ref={(el) => (itemRefs.current[index] = el)} key={item.key}>
            <GenericTagComp
              color={item.color}
              text={item.label}
              onChipClick={(e) => handleSideCard(e, rowData, item.key,childSc)}
              tagIcon={item?.tagIcon}
            />
          </div>
        ))}
        {visibleCount < tabConfig.length && (
          <div ref={moreRef}>
            <GenericTagComp
              color="gray"
              text={`+${tabConfig.length - visibleCount}`}
              onChipClick={handleMoreClick}
            />
          </div>
        )}
      </div>
      {Dropdown}
    </>
  );
};

export default TagOverflowHandler;
